import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4}
    height={422}
    fill="none"
    {...props}
  >
    <path fill="url(#afg)" d="M0 398h4v4H0z" />
    <path fill="url(#bfg)" d="M0 408h4v4H0z" />
    <path fill="url(#cfg)" d="M0 418h4v4H0z" />
    <path
      stroke="url(#dfg)"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M2 1v386"
    />
    <defs>
      <linearGradient
        id="afg"
        x1={2}
        x2={2}
        y1={398}
        y2={402}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B8876" />
        <stop offset={1} stopColor="#AEA373" />
      </linearGradient>
      <linearGradient
        id="bfg"
        x1={2}
        x2={2}
        y1={408}
        y2={412}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B8876" />
        <stop offset={1} stopColor="#AEA373" />
      </linearGradient>
      <linearGradient
        id="cfg"
        x1={2}
        x2={2}
        y1={418}
        y2={422}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B8876" />
        <stop offset={1} stopColor="#AEA373" />
      </linearGradient>
      <linearGradient
        id="dfg"
        x1={2.544}
        x2={2.544}
        y1={-100.376}
        y2={544.002}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCFA2" />
        <stop offset={0.095} stopColor="#8C866B" />
        <stop offset={0.24} stopColor="#8C866A" />
        <stop offset={0.475} stopColor="#F5E6B6" />
        <stop offset={0.62} stopColor="#8C866B" />
        <stop offset={0.86} stopColor="#8C866B" />
        <stop offset={1} stopColor="#A59A87" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
